/**
 * Account-type helpers shared across components.
 *
 * Mirrors the backend's canonical liability rule (LIABILITY_TYPES in
 * account_tools.py / _DEBT_ACCOUNT_TYPES in routers/goals.py): credit, loan,
 * and mortgage balances are money owed and must subtract from net worth.
 */

export const LIABILITY_ACCOUNT_TYPES = new Set(['credit', 'loan', 'mortgage']);

/** True when the account's balance represents debt rather than an asset. */
export const isLiability = (accountType: string | null | undefined): boolean =>
  LIABILITY_ACCOUNT_TYPES.has((accountType ?? '').toLowerCase());
